// Shared social links and channel config
export const TWITCH_CHANNEL = "itz_ool";

export const SOCIALS = {
    twitch: { label: "Twitch", url: "https://twitch.tv/itz_ool", handle: "itz_ool" },
    discord: { label: "Discord", url: "https://discord.gg/Kb5NyrcwgA", handle: "discord.gg/Kb5NyrcwgA" },
    youtube: { label: "YouTube", url: "https://www.youtube.com/@Twitch_Ool", handle: "Twitch_Ool" },
    tiktok: { label: "TikTok", url: "https://www.tiktok.com/@itz_ool", handle: "@itz_ool" },
    instagram: { label: "Instagram", url: "https://www.instagram.com/twitchool", handle: "@twitchool" },
    x: { label: "X", url: "https://x.com/coolnightduck", handle: "@coolnightduck" },
};

export const BUSINESS_EMAIL = "itzoolbusiness@gmail.com";
